import React, { createContext, useMemo } from 'react';
import { Wizard } from 'react-use-wizard';
import AnimatedWrapper from './AminatedWrapper';
import StepUrlUpdater, { getStepKeyFromUrl } from './StepUrlUpdater';

// Create context to share navigation direction
const NavigationContext = /*#__PURE__*/createContext();
const AppWizard = _ref => {
  let {
    stepConfig
  } = _ref;
  // Convert stepConfig to array sorted by index
  const sortedSteps = useMemo(() => Object.values(stepConfig).sort((a, b) => a.index - b.index), [stepConfig]);
  const stepsCount = sortedSteps.length;

  // Create reverse mapping from key to index
  const keyToIndexMap = useMemo(() => sortedSteps.reduce((acc, _ref2) => {
    let {
      index,
      key
    } = _ref2;
    if (key) acc[key] = index;
    return acc;
  }, {}), [sortedSteps]);

  // Create mapping from index to key
  const indexToKeyMap = useMemo(() => sortedSteps.reduce((acc, _ref3) => {
    let {
      index,
      key
    } = _ref3;
    if (key) acc[index] = key;
    return acc;
  }, {}), [sortedSteps]);

  // Get initial step from URL parameter
  const getInitialStep = () => {
    const stepKey = getStepKeyFromUrl();
    if (stepKey && keyToIndexMap[stepKey] !== undefined) {
      return keyToIndexMap[stepKey];
    }
    return 0; // Default to first step
  };

  // Component to handle URL parameter updates - integrated into the wrapper
  const WizardWrapper = _ref4 => {
    let {
      children
    } = _ref4;
    return /*#__PURE__*/React.createElement(AnimatedWrapper, {
      stepsCount: stepsCount,
      NavigationContext: NavigationContext
    }, /*#__PURE__*/React.createElement(StepUrlUpdater, {
      indexToKeyMap: indexToKeyMap
    }), children);
  };
  return /*#__PURE__*/React.createElement(Wizard, {
    wrapper: /*#__PURE__*/React.createElement(WizardWrapper, null),
    startIndex: getInitialStep()
  }, sortedSteps.map((step, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, step.render(NavigationContext))));
};
export default AppWizard;